module.exports = __webpack_public_path__ + "img/finding-us-01.77b64403.jpg";